/* Compare current reference membership with Shopify's native filtered index.
 * Recover proven mismatches using verified Shopify-rendered product cards.
 * Never invent product markup, prices, availability, or reference assignments.
 */
(function (root, factory) {
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) root.MerlonsFilterFreshness = api;
}(typeof window !== 'undefined' ? window : null, function (win) {
  'use strict';
  var keys = (win ? win.MerlonsFilterIndex : require('./merlons-filter-index.js')).GROUPS;
  var prefix = 'filter.p.m.merlons_catalog.filter_';
  function hasReferences(params) {
    return keys.some(function (key) { return params.getAll(prefix + key + '_reference').some(Boolean); });
  }
  function referenceContext(params) {
    var next = new URLSearchParams(params);
    next.delete('merlons_offer'); next.delete('merlons_sort');
    return next;
  }
  function sameIds(left, right) {
    var a = new Set(left.map(String)), b = new Set(right.map(String));
    return a.size === b.size && Array.from(a).every(function (id) { return b.has(id); });
  }
  function fingerprint(options, params, pathname) {
    var query = new URLSearchParams(params); query.sort();
    return JSON.stringify([pathname, query.toString(), (options.sourceURLs || []).slice().sort(), (options.scopeHandles || []).slice().sort(), Boolean(options.search)]);
  }
  function compareRendered(snapshot, rendered) {
    if (!snapshot.nativeMatches && !snapshot.recovered) return false;
    var expected = new Set(snapshot.ids.map(String));
    if (rendered.finishedEmpty && expected.size > 0) return false;
    if (rendered.ids.some(function (id) { return !expected.has(String(id)); })) return false;
    // A paginated page is a subset. Complete identity is checked between the
    // two metadata probes, not against the first screen of product cards.
    if (rendered.checkTotal && rendered.total !== expected.size) return false;
    if (rendered.checkTotal && rendered.completePage && !sameIds(snapshot.ids, rendered.ids)) return false;
    return true;
  }
  function recoveryOrder(products, params, locale) {
    var ordered = products.slice(), mode = params.get('merlons_sort'), sort = params.get('sort_by');
    var comparators = {
      'price-ascending':function(a,b){return a.priceMin-b.priceMin;},
      'price-descending':function(a,b){return b.priceMin-a.priceMin;},
      'title-ascending':function(a,b){return a.title.localeCompare(b.title,locale);},
      'title-descending':function(a,b){return b.title.localeCompare(a.title,locale);},
      'created-ascending':function(a,b){return a.createdAt-b.createdAt;},
      'created-descending':function(a,b){return b.createdAt-a.createdAt;}
    };
    if (mode === 'discount' || mode === 'liquidation') ordered.sort(function(a,b){return b.discountRatio-a.discountRatio;});
    else if (comparators[sort]) ordered.sort(comparators[sort]);
    return ordered;
  }
  function sameProduct(expected, actual) {
    if (!actual || String(expected.id) !== String(actual.id)) return false;
    if (expected.available !== actual.available || expected.priceMin !== actual.priceMin || expected.priceMax !== actual.priceMax) return false;
    if (expected.title !== actual.title || expected.createdAt !== actual.createdAt || expected.discountRatio !== actual.discountRatio) return false;
    if (!sameIds(expected.collections,actual.collections || []) || !sameIds(expected.offers,actual.offers || [])) return false;
    return keys.every(function(key) {
      return Array.isArray(actual.values && actual.values[key]) && sameIds(expected.values[key].map(function(v){return v.id;}),actual.values[key].map(function(v){return v.id;}));
    });
  }
  var api = {hasReferences:hasReferences, referenceContext:referenceContext, sameIds:sameIds, fingerprint:fingerprint, compareRendered:compareRendered,recoveryOrder:recoveryOrder,sameProduct:sameProduct};
  if (!win || !win.document) return api;
  var doc = win.document;
  var snapshot = null;
  var retryTimer = null;
  var retryKey = '';
  var retries = 0;
  var observedContainer = null;
  var observer = null;
  var pendingFrame = false;
  var recovery = null;
  var language = (doc.documentElement.lang || 'ka').split('-')[0];
  var messages = {
    ka: {updating:'პროდუქტები იტვირთება…', error:'პროდუქტები ვერ ჩაიტვირთა. გთხოვთ, სცადოთ ხელახლა.', retry:'ხელახლა ცდა', more:'მეტის ნახვა'},
    en: {updating:'Loading products…', error:'Products could not load. Please try again.', retry:'Try again', more:'Load more'},
    ru: {updating:'Загружаем товары…', error:'Не удалось загрузить товары. Попробуйте ещё раз.', retry:'Повторить', more:'Показать ещё'}
  };
  var copy = messages[language] || messages.ka;
  function collectionRoot() { return doc.getElementById('main-collection-filters'); }
  function currentKey() { return win.location.pathname + win.location.search; }
  function clearTimer() { if (retryTimer) win.clearTimeout(retryTimer); retryTimer = null; }
  function statusNode() {
    var root = collectionRoot();
    var container = doc.getElementById('CollectionProductContainer');
    if (!root || !container) return null;
    var node = root.querySelector('[data-merlons-freshness-status]');
    if (!node) {
      node = doc.createElement('div');
      node.className = 'merlons-filter-freshness-status';
      node.setAttribute('data-merlons-freshness-status', '');
      node.hidden = true;
      var text = doc.createElement('p');
      text.setAttribute('role','status'); text.setAttribute('aria-live','polite');
      var button = doc.createElement('button');
      button.type = 'button'; button.className = 'btn'; button.textContent = copy.retry;
      button.setAttribute('data-merlons-freshness-retry','');
      node.append(text,button);
      container.insertAdjacentElement('beforebegin',node);
    }
    return node;
  }
  function release() {
    var root = collectionRoot();
    if (root) root.removeAttribute('data-merlons-filter-stale');
    var node = root && root.querySelector('[data-merlons-freshness-status]');
    if (node) node.hidden = true;
    clearTimer();
    retries = 0;
  }
  function cancelRecovery() {
    if (!recovery) return;
    recovery.controller.abort();
    if (recovery.timer) win.clearTimeout(recovery.timer);
    if (recovery.button) recovery.button.remove();
    recovery = null;
  }
  function cancelOtherRenderers() {
    var form=doc.querySelector('collection-filter-product');
    if (form && typeof form.constructor.abortPendingRequests === 'function') form.constructor.abortPendingRequests(true);
    ['merlonsCancelCollectionSearch','merlonsCancelCollectionInfiniteScroll','merlonsCancelCategoryHierarchy','merlonsCancelCollectionLocalSort'].forEach(function(name) {
      if (typeof win[name] === 'function') win[name]();
    });
    var root = collectionRoot();
    if (root) ['data-merlons-search-loading','data-merlons-special-loading','data-merlons-hierarchy-loading'].forEach(function(name){root.removeAttribute(name);});
  }
  function currentRecovery(state) {
    return recovery === state && !state.controller.signal.aborted && state.location === currentKey() && state.root === collectionRoot() && state.grid === doc.getElementById('product-grid');
  }
  function recoveryCounts(state) {
    state.root.querySelectorAll('.pagination__count').forEach(function(node) {
      node.hidden = false;
      var count = node.querySelector('.count'), total = node.querySelector('.total');
      if (count) count.textContent = String(state.rendered-state.start);
      if (total) total.textContent = String(state.products.length);
    });
    state.root.querySelectorAll('.pagination__bar').forEach(function(node) {
      node.hidden = false; node.setAttribute('data-max',String(state.products.length));
      var progress = node.querySelector('.progress');
      if (progress) progress.style.width = (state.products.length ? Math.min(100,(state.rendered-state.start)/state.products.length*100) : 0) + '%';
    });
    if (state.root.classList.contains('page-search')) {
      state.root.dataset.merlonsSearchResultsCount = String(state.products.length);
      var heading = doc.querySelector('#NovBreadcrumbs h1');
      if (heading && state.root.dataset.merlonsSearchHeadingTemplate) heading.textContent = state.root.dataset.merlonsSearchHeadingTemplate.replace('__COUNT__',String(state.products.length));
    }
  }
  function fetchRecoveryCard(product, state) {
    if (typeof product.handle !== 'string' || !product.handle) return Promise.reject(new Error('Product card handle is missing'));
    var allPath = state.root.dataset.merlonsAllProductsPath || (language === 'ka' ? '' : '/' + language) + '/collections/all';
    var prefixPath = new URL(allPath,win.location.origin).pathname.split('/collections/')[0];
    var url = new URL(prefixPath + '/products/' + encodeURIComponent(product.handle),win.location.origin);
    url.searchParams.set('view','merlons-filter-card');
    // Local/Shopify preview transport must stay on the theme under test.
    var preview = new URLSearchParams(win.location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id',preview);
    return win.fetch(url.toString(),{cache:'no-store',signal:state.controller.signal}).then(function(response) {
      if (!response.ok) throw new Error('Product card request failed');
      return response.text();
    }).then(function(html) {
      var parsed = new win.DOMParser().parseFromString(html,'text/html');
      var cards = parsed.querySelectorAll('.product--item[data-product-id]');
      var metadata = parsed.querySelector('script[data-merlons-recovery-product]');
      if (cards.length !== 1 || String(cards[0].dataset.productId) !== String(product.id) || !metadata) throw new Error('Unexpected product card response');
      if (!sameProduct(product,JSON.parse(metadata.textContent))) throw new Error('Product data changed while loading; retry required');
      return doc.importNode(cards[0],true);
    });
  }
  function loadRecoveryPage(state, initial) {
    if (!currentRecovery(state) || state.loading) return Promise.resolve();
    state.loading = true;
    var start = state.rendered, end = Math.min(state.products.length,start+state.batchSize);
    var selected = state.products.slice(start,end), cards = new Array(selected.length), next = 0;
    if (state.button) { state.button.disabled = true; state.button.textContent = copy.updating; }
    state.timer = win.setTimeout(function(){state.timedOut=true;state.controller.abort();},25000);
    function worker() {
      var index = next++;
      if (index >= selected.length) return Promise.resolve();
      return fetchRecoveryCard(selected[index],state).then(function(card){cards[index]=card;return worker();});
    }
    return Promise.all(Array.from({length:Math.min(4,selected.length)},worker)).then(function() {
      if (!currentRecovery(state)) return;
      if (initial) {
        cancelOtherRenderers();
        state.root.querySelectorAll('.paging,.nov-pagination,.collection__btn-loadmore,.scroll__infinityfilter,[data-merlons-infinite-scroll],[data-merlons-query-infinite-scroll],[data-merlons-category-hierarchy-scroll]').forEach(function(node){node.remove();});
        state.grid.replaceChildren();
        state.grid.classList.remove('text-center','pt-60','pt-40','pb-40');
        state.grid.classList.add('product-collection','collection__grid-loadmore','row','grid--view-items','spacing-md-15');
        state.grid.removeAttribute('data-next-url');
      }
      var fragment = doc.createDocumentFragment();
      cards.forEach(function(card){fragment.appendChild(card);});
      state.grid.appendChild(fragment);
      if (!state.products.length) {
        var empty = doc.createElement('div'); empty.className='col-12 text-center';
        empty.textContent=state.root.dataset.merlonsEmptyLabel || ''; state.grid.appendChild(empty);
      }
      state.rendered=end;
      state.grid.dataset.currentPage=String(Math.max(1,Math.ceil(end/state.batchSize)));
      state.grid.dataset.totalPages=String(Math.max(1,Math.ceil(state.products.length/state.batchSize)));
      state.grid.dataset.totalProducts=String(state.products.length);
      state.grid.dataset.merlonsReferenceRecovery='true';
      if (!state.button && end < state.products.length) {
        state.button=doc.createElement('button');state.button.type='button';state.button.className='btn d-block mx-auto mt-30';
        state.button.setAttribute('data-merlons-recovery-more','');
        state.button.addEventListener('click',function(){loadRecoveryPage(state,false);});
        state.grid.insertAdjacentElement('afterend',state.button);
      }
      if (state.button) {state.button.hidden=end>=state.products.length;state.button.disabled=false;state.button.textContent=state.root.dataset.merlonsLoadMoreLabel || copy.more;}
      state.proof.recovered=true;
      recoveryCounts(state);
      if (typeof win.merlonsRebindCollectionCards === 'function') win.merlonsRebindCollectionCards(state.grid);
      release();
      doc.dispatchEvent(new CustomEvent('merlons:collection:appended',{detail:{count:cards.length,recovery:true}}));
    }).catch(function(error) {
      if (recovery !== state || state.location !== currentKey()) return;
      if (error.name === 'AbortError' && !state.timedOut) return;
      if (initial) hold(true);
      else if (state.button) {state.button.disabled=false;state.button.textContent=copy.retry;}
      // A timeout needs a fresh controller for an explicit load-more retry.
      if (state.timedOut) {state.controller=new AbortController();state.timedOut=false;}
      console.warn('[Merlons filter recovery]',error.message);
    }).finally(function(){if(state.timer)win.clearTimeout(state.timer);state.timer=null;state.loading=false;});
  }
  function recover(proof) {
    cancelRecovery();
    cancelOtherRenderers();
    var root=collectionRoot(),grid=doc.getElementById('product-grid');
    if (!root || !grid || !proof.products) {hold(true);return;}
    var params=new URLSearchParams(win.location.search);
    var batchSize=win.matchMedia('(max-width: 767px)').matches ? 12 : 24;
    var products=recoveryOrder(proof.products,params,language);
    var page=Math.min(Math.max(1,Math.ceil(products.length/batchSize)),Math.max(1,Math.floor(Number(params.get('page'))||1)));
    var offset=(page-1)*batchSize;
    proof.ids=products.map(function(product){return String(product.id);});
    recovery={root:root,grid:grid,location:currentKey(),products:products,start:offset,rendered:offset,batchSize:batchSize,controller:new AbortController(),proof:proof};
    hold(false);
    return loadRecoveryPage(recovery,true);
  }
  function retry(automatic) {
    clearTimer();
    if (retryKey !== currentKey()) return;
    var form = doc.querySelector('collection-filter-product');
    if (form && typeof form.constructor.renderPage === 'function') {
      // This is an ordinary section refresh, with the same URL, no new history
      // entry, no cache-busting URL and no recurring background polling.
      form.constructor.renderPage(win.location.search.slice(1), null, false);
    } else if (!automatic) win.location.reload();
  }
  function hold(failed) {
    var root = collectionRoot(), node = statusNode();
    if (!root || !node) return;
    root.setAttribute('data-merlons-filter-stale','true');
    node.querySelector('p').textContent = failed ? copy.error : copy.updating;
    node.querySelector('button').hidden = !failed;
    node.hidden = false;
    if (retryKey !== currentKey()) { retryKey = currentKey(); retries = 0; }
  }
  function isCurrent() {
    return snapshot && snapshot.location === currentKey() && snapshot.root === collectionRoot();
  }
  function checkDOM() {
    if (!isCurrent()) return;
    if (!snapshot.nativeMatches && !snapshot.recovered) { if (!recovery || !recovery.loading) hold(true); return; }
    var root = collectionRoot(), grid = doc.getElementById('product-grid');
    if (!grid) return;
    // Existing asynchronous renderers own their loading phase. Check their
    // final grid once their loading marker is removed, not an intermediate grid.
    if (root.hasAttribute('data-merlons-search-loading') || root.hasAttribute('data-merlons-special-loading')) return;
    var params = new URLSearchParams(win.location.search);
    var checkTotal = snapshot.singleSource && root.dataset.merlonsHierarchyActive !== 'true'
      && !params.get('q') && !params.getAll('merlons_offer').length
      && !params.get('merlons_sort') && !root.classList.contains('page-search');
    var ids = Array.from(grid.querySelectorAll('.product--item[data-product-id]')).map(function (node) { return node.dataset.productId; });
    var totalText = grid.getAttribute('data-total-products');
    var total = totalText === null ? (ids.length ? NaN : 0) : Number(totalText);
    var hierarchy = root.dataset.merlonsHierarchyActive === 'true';
    var hierarchyDone = root.querySelector('[data-merlons-category-hierarchy-scroll].is-complete:not(.is-error)');
    var finishedEmpty = totalText !== null && total === 0 && ids.length === 0
      && Number(params.get('page') || 1) === 1 && !params.getAll('merlons_offer').length && !params.get('merlons_sort')
      && (!hierarchy || (hierarchyDone && !root.hasAttribute('data-merlons-hierarchy-loading')));
    checkTotal = checkTotal && Number.isInteger(total) && total >= 0;
    var completePage = Number(grid.getAttribute('data-current-page') || 1) === 1 && Number(grid.getAttribute('data-total-pages') || 1) <= 1;
    if (compareRendered(snapshot, {ids:ids,total:total,checkTotal:checkTotal,completePage:completePage,finishedEmpty:Boolean(finishedEmpty)})) release();
    else hold(true);
  }
  function observe() {
    var container = doc.getElementById('CollectionProductContainer'), root = collectionRoot();
    if (!container || container === observedContainer || !win.MutationObserver) return;
    if (observer) observer.disconnect();
    observedContainer = container;
    observer = new win.MutationObserver(function () {
      if (pendingFrame) return;
      pendingFrame = true;
      win.requestAnimationFrame(function () { pendingFrame = false; checkDOM(); });
    });
    observer.observe(container,{childList:true,subtree:true,attributes:true,attributeFilter:['data-total-products','data-total-pages']});
    observer.observe(root,{attributes:true,attributeFilter:['data-merlons-search-loading','data-merlons-special-loading','data-merlons-hierarchy-loading']});
  }
  api.verify = function (data, options, params) {
    if (!hasReferences(params)) return Promise.resolve(null);
    var refParams = referenceContext(params);
    var ids = win.MerlonsFilterIndex.select(data.products,data.filters,refParams).map(function (product) { return String(product.id); });
    var nativeOptions = Object.assign({}, options, {preserveReferences:true});
    if (options.search) {
      // Shopify's search and collection metafield indexes can disagree. Verify
      // native reference membership independently, intersected with native text
      // search membership. Never accept a stale/partial reference assignment.
      nativeOptions.search = false;
      nativeOptions.sourceURLs = [collectionRoot().dataset.merlonsAllProductsPath || ((language === 'ka' ? '' : '/' + language) + '/collections/all')];
    }
    return win.MerlonsFilterIndex.load(nativeOptions).then(function (nativeData) {
      var sourceIds = new Set(data.products.map(function (product) { return String(product.id); }));
      var nativeIds = nativeData.products.filter(function (product) { return !options.search || sourceIds.has(String(product.id)); }).map(function (product) { return String(product.id); });
      return {ids:ids,nativeMatches:sameIds(ids,nativeIds),products:win.MerlonsFilterIndex.select(data.products,data.filters,params),
        fingerprint:fingerprint(options,params,win.location.pathname),singleSource:options.sourceURLs.length === 1 && !(options.scopeHandles || []).length};
    });
  };
  api.commit = function (result) {
    if (!result) { cancelRecovery(); snapshot = null; release(); return; }
    // Opening the filter drawer rechecks metadata without requesting a new grid.
    // Preserve verified cards and load-more progress while that proof is unchanged.
    if (recovery && currentRecovery(recovery) && recovery.proof.fingerprint === result.fingerprint
      && recovery.proof.products.length === result.products.length
      && recovery.proof.products.every(function(product,index){return sameProduct(product,result.products[index]);})) {
      snapshot=recovery.proof;
      if (!recovery.loading) checkDOM();
      return;
    }
    snapshot = Object.assign({},result,{location:currentKey(),root:collectionRoot()});
    observe();
    if (!snapshot.nativeMatches || recovery) return recover(snapshot);
    cancelRecovery(); checkDOM();
  };
  api.reset = function () {
    cancelRecovery();
    snapshot = null; clearTimer();
    // A known stale grid stays held across offer/sort/reference transitions.
    // Only a verified replacement (or removing all references) can release it.
    if (!hasReferences(new URLSearchParams(win.location.search))) {
      retries = 0; retryKey = currentKey(); release();
    }
  };
  api.fail = function () {
    var root = collectionRoot();
    if (!root || root.dataset.merlonsFilterStale !== 'true') return false;
    // Bootstrap can fail before any membership proof exists. Always expose a
    // user-operated retry instead of leaving a hidden grid without recovery.
    hold(true);
    clearTimer();
    return true;
  };
  doc.addEventListener('merlons:filters:request', api.reset);
  doc.addEventListener('merlons:collection:appended',checkDOM);
  doc.addEventListener('merlons:collection:rendered',function () { observe(); checkDOM(); });
  doc.addEventListener('click',function (event) {
    if (!event.target.closest('[data-merlons-freshness-retry]')) return;
    retryKey = currentKey(); retry(false);
  });
  win.addEventListener('pagehide',function () { cancelRecovery(); clearTimer(); snapshot = null; if (observer) observer.disconnect(); observedContainer = null; });
  return api;
}));
